import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend) // Loads translations dynamically
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Integrates with React
  .init({
    fallbackLng: "en",
    debug: false,
    detection: {
      order: ["localStorage", "navigator"], // Checks localStorage first
      caches: ["localStorage"], // Saves selected language
    },
    backend: {
      loadPath: "/locales/{{lng}}.json", // Loads JSON translation files
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
